<template>
  <li :class="[backgroundColorClass]" @click="folder.checked = !folder.checked">
    <div><input v-model="folder.checked" type="checkbox" /></div>
    <div class="description">
      <div>{{ folder.foldername }}</div>
      <div><strong>{{ status }}</strong></div>
      <div v-if="folder.files" class="filecount">
        ({{ numberOfFilesLeft }} / {{ folder.files.length }} {{ i18n_labelNeedSync }})
      </div>
    </div>
  </li>
</template>

<script>
    export default {
        props: {
            folder: null,
            i18n_labelNeedSync: String
        },
        computed: {
            folderid: function() {
                return 'folder_' + this.folder.foldername;
            },
            numberOfFilesLeft: function () {
                if (!this.folder || !this.folder.files) return 0;
                return this.folder.files.filter((file => {return file.status !== 'sync'})).length;
            },
            status: function() {
                return this.folder.status;
            },
            backgroundColorClass: function() {
                if (!this.folder || !this.folder.status) return "";

                if (this.folder.status === 'sync') {
                    //console.log(this.numberOfFilesLeft)
                    if (this.numberOfFilesLeft === 0 ) {
                        return "folderstate_sync_empty";
                    }
                    return 'folderstate_sync'
                }
                if (this.folder.status === 'nosync') {
                    return 'folderstate_nosync';
                }
                if (this.folder.status === 'deleted') {
                    return 'folderstate_deleted';
                }

            }
        },
        methods: {

        }

    };
</script>

<style scoped>
    li {
        display: flex;
        align-items: center;
    }

    input[type=checkbox] {
        transform: scale(1.5);
    }

    .description {
        margin: 10px;
    }

    .filecount {
        width: 100%;
        text-align: center;
        font-size: 1.2em;
        padding: 5px;
    }

    .folderstate_sync_empty {
        background-color: lightgreen;
    }

    .folderstate_sync {
        background-color: #FAFAD2;
    }

    .folderstate_nosync {
        background-color: #DDD;
    }

    .folderstate_deleted {
        background-color: orange;
    }

    @media (prefers-color-scheme: dark) {
        .folderstate_sync_empty, .folderstate_sync, .folderstate_nosync, .folderstate_deleted {
            color: black
        }
    }

</style>
